import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import hdfcLogo from "../../../assets/hdfc-ergo-logo.webp";
import styles from "./LogoContainer.module.css";
import AnnouncementIcon from "../../global-components/CommonIcons/AnnouncementIcon";
import { getAnnouncementMsg } from "../../../services/announcement-msg";
import Marquee from "react-fast-marquee";
function LogoContainer() {
  const { channelUrl } = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );

  let url = "maruti";

  const [msg, setMsg] = useState([]);
  useEffect(() => {
    getAnnouncementMsg().then((data) => {
      setMsg(data);
    });
  }, []);

  return (
    <>
      {channelUrl === "maruti" ? (
        <>
          <div className=" flex flex-col h-72 w-full px-[16px] mt-[30px]">
            <div className="flex  items-center justify-between ">
              <div>
                <img
                  className={styles["logo-image"]}
                  src="assets/hdfc-ergo-logo.webp"
                  alt="hdfc-ergo-logo"
                />
              </div>
              <div>
                <img
                  src="/assets/ms_logo.png"
                  alt="MS-logo"
                  className="w-[182px] h-[30px]"
                />
              </div>
            </div>
            <div className="md:ml-4 text-center py-[100px]">
              <p className="text-[#113569] font-bold text-lg mb-1">
                KYC has been made easier!
              </p>
              <p className="text-[#113569] text-sm font-medium mb-4 ">
                Choose your digital-friendly options.
              </p>
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center h-72 w-full ">
          <div className="flex flex-col items-center justify-center">
            <img
              className={styles["logo-image"]}
              src="assets/hdfc-ergo-logo.webp"
              alt="hdfc-ergo-logo"
            />
            <label className={styles["logo-tagline"]}>
              Let's complete your kYC
            </label>
            <div>
              <p className="font-bold text-lg mb-1">
                KYC has been made easier!
              </p>
              <p className="text-sm font-medium mb-4 ">
                Choose your digital-friendly options.
              </p>
            </div>
            {msg[0] && msg[0]?.data && msg[0].data[0]?.message && <Marquee
              scrollamount="10"
              style={{ width: "80vw", fontWeight: "600" }}
              className="lg:text-[0.80rem] font-medium bottom-0 right-0 text-[0.70rem] mb-2 text-gray-600"
            >
              <div className="flex items-center">
                {msg[0]?.data?.map((anMsg) => {
                  return (
                    <>
                      <AnnouncementIcon />
                      &emsp;
                      <b className="text-red-500">{anMsg?.prefix}:</b>&emsp;
                      {anMsg?.message}&emsp;
                    </>
                  );
                })}
              </div>
            </Marquee>}
          </div>
        </div>
      )}
    </>
  );
}

export default LogoContainer;

//   <div className={styles["logo-container"]}>
